import React, { useEffect, useState } from "react";
import CRMService from "src/services/CRMService";
import IconBase from "src/components/IconBase";
import "./styles.scss";

const getTextColor = (index) => {
    const textColors = ["#FF4500", "#FFD700", "#FFA500", "#014281", "#006500"];
    return textColors[index] || "#FFFFFF";
};

const getStarColor = (index) => getTextColor(index);

function Index() {
    const [topListSale, setTopListSale] = useState([]);
    const [topListOrder, setTopListOrder] = useState([]);
    const [isMoving, setIsMoving] = useState(false);

    // useEffect(() => {
    //     let animationTimeout;
    //     let waitTimeout;

    //     // const getTopRate = async () => {
    //     //     try {
    //     //         const { success } = await CRMService.getTopSales();
    //     //         setTopListSale(success?.sale || []);
    //     //         // setTopListOrder(success?.order || []);
    //     //     } catch (e) {
    //     //         console.error(e);
    //     //     }
    //     // };

    //     // const handleAnimationCycle = async () => {
    //     //     await getTopRate();

    //     //     setIsMoving(true);

    //     //     // animation là 20s)
    //     //     const animationDuration = 20000;
    //     //     animationTimeout = setTimeout(() => {
    //     //         setIsMoving(false);
    //     //     }, animationDuration);

    //     //     const waitDuration = 300000;
    //     //     waitTimeout = setTimeout(() => {
    //     //         handleAnimationCycle();
    //     //     }, animationDuration + waitDuration);
    //     // };

    //     // handleAnimationCycle().then()

    //     // return () => {
    //     //     clearTimeout(animationTimeout);
    //     //     clearTimeout(waitTimeout);
    //     // };
    // }, []);

    return (
        <div style={{ display: "flex", width: "100%", overflow: "hidden" }}>
            {isMoving ? (
                <div className="moving-content">
                    {topListSale.map((item, index) => (
                        <div
                            key={item.ID}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "30px",
                            }}
                        >
                            <div
                                style={{ color: getTextColor(index) }}
                                className="wrapper"
                            >
                                <span>{`${index + 1}`}</span>
                                <IconBase
                                    name="star"
                                    size={"medium"}
                                    color={getStarColor(index)}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        color: getTextColor(index),
                                    }}
                                >
                                    {item.name}
                                </span>
                                <span
                                    style={{
                                        fontSize: "14px",
                                        color: getTextColor(index),
                                    }}
                                >
                                    Doanh số:{" "}
                                    {parseInt(item.total_sales).toLocaleString()}
                                    đ
                                </span>
                                <span
                                    style={{
                                        fontSize: "13px",
                                        color: getTextColor(index),
                                    }}
                                >
                                    Đơn hàng:{" "}
                                    {item.total_order ? parseInt(item.total_order).toLocaleString() : 0}
                                </span>
                            </div>
                        </div>
                    ))}
                    {/*{topListOrder.map((item, index) => (*/}
                    {/*    <div*/}
                    {/*        key={item.ID}*/}
                    {/*        style={{*/}
                    {/*            display: "flex",*/}
                    {/*            alignItems: "center",*/}
                    {/*            marginRight: "8px",*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <div*/}
                    {/*            style={{color: getTextColor(index)}}*/}
                    {/*            className="wrapper"*/}
                    {/*        >*/}
                    {/*            <span style={{fontSize: '18px', fontWeight: 'bold'}}>{`${index + 1}`}</span>*/}
                    {/*            <IconBase*/}
                    {/*                name="star"*/}
                    {/*                size={"smallest"}*/}
                    {/*                color={getStarColor(index)}*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*        <div*/}
                    {/*            style={{*/}
                    {/*                display: "flex",*/}
                    {/*                flexDirection: "column",*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            <span*/}
                    {/*                style={{*/}
                    {/*                    fontSize: "16px",*/}
                    {/*                    fontWeight: "bold",*/}
                    {/*                    color: getTextColor(index),*/}
                    {/*                }}*/}
                    {/*            >*/}
                    {/*                {item.name}*/}
                    {/*            </span>*/}
                    {/*            <span*/}
                    {/*                style={{*/}
                    {/*                    fontSize: "15px",*/}
                    {/*                    color: getTextColor(index),*/}
                    {/*                }}*/}
                    {/*            >*/}
                    {/*                Tổng đơn:{" "}*/}
                    {/*                {parseInt(item.total_order).toLocaleString()}*/}
                    {/*            </span>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*))}*/}
                </div>
            ) : null}
        </div>
    );
}

export default React.memo(Index);
